import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import XplorerTable from '@blade-sxp/pass/components/xplorer-table.vue';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
import { StaffModule } from '@blade-sxp/pass/store/staff';
import { EType } from '@blade/common/interfaces/user-group';
import moment from 'moment';
import { handleError } from '@blade/common/utils/handle-error';
import InvisibleNumber from '@blade/common/components/invisible-number.vue';
let default_1 = class default_1 extends Vue {
    childId;
    pagination = {
        page: 1,
        size: 10,
        total: 0,
    };
    whiteStaff = [];
    listLoading = false;
    params = {
        dateEnd: '',
        dateStart: '',
        keywords: '',
        personGroup: EType.GUEST,
        relation: true,
        sort: 'DESC',
        libId: [],
    };
    portraitsToExport = [];
    groupFilters = [];
    handleSizeChange(size) {
        this.pagination.size = size;
        this.pagination.page = 1;
        this.getData();
    }
    handleCurrentChange(curr) {
        this.pagination.page = curr;
        this.getData();
    }
    handleFullScreen() {
        document.body.requestFullscreen();
    }
    handleRefresh() {
        this.getData();
    }
    handleSelectionChange(val) {
        console.log('val:', val);
        this.portraitsToExport = val.map((item) => item.portraitId);
    }
    handleCreate() {
        this.$router.push('/traffic/staff/visitor/visitor-create');
    }
    handleEdit(row) {
        this.$router.push(`/traffic/staff/visitor/visitor-edit/${row.portraitId}`);
    }
    async mounted() {
        await this.getGroup();
        this.getData();
        this.$refs['staff-table'] && this.$refs['staff-table'].clearSelection();
        this.params.libId.push(...this.childId);
    }
    async getGroup() {
        try {
            const res = await StaffModule.getPortraitsGroup({ data: EType.GUEST, mode: 'CREATE' });
            this.groupFilters = res.data?.map((item) => ({ text: item.name, value: item.libId }));
        }
        catch (e) { }
    }
    async getData() {
        this.listLoading = true;
        try {
            const res = await StaffModule.getPassportraits({ ...this.params, page: this.pagination.page, size: this.pagination.size });
            const { list, total } = res.data;
            this.whiteStaff = this.mapListData(list);
            this.pagination.total = total;
            this.listLoading = false;
        }
        catch (e) {
            this.listLoading = false;
        }
    }
    mapListData(list) {
        return list.map((item) => {
            const { portraitId, startTime, expirationTime } = item;
            return {
                ...item,
                id: portraitId,
                validDuration: `${moment(startTime).format('YYYY-MM-DD')}~${moment(expirationTime).format('YYYY-MM-DD')}`,
            };
        });
    }
    async handleSearch(search) {
        this.listLoading = true;
        try {
            const { keywords, ...rest } = this.params;
            const res = await StaffModule.getPassportraits({ ...rest, keywords: search, page: 1, size: this.pagination.size });
            console.log('res:', res);
            const { list, total } = res.data;
            this.whiteStaff = list;
            this.pagination.total = total;
            this.pagination.page = 1;
            this.listLoading = false;
        }
        catch (e) {
            this.listLoading = false;
        }
    }
    handleDelete(row) {
        this.$confirm(`${this.$t('deleteUser').toString()} ${row.name}?`, 'Warning', {
            confirmButtonText: this.$t('confirm').toString(),
            cancelButtonText: this.$t('cancel').toString(),
            type: 'warning',
        })
            .then(async () => {
            try {
                await StaffModule.deletePortrait(row.portraitId);
                this.$elmessage.success({
                    type: 'success',
                    message: this.$t('deleted').toString(),
                });
                this.getData();
            }
            catch (e) {
                handleError(e);
            }
        })
            .catch(() => { });
    }
    handleUpload() {
        this.$router.push('/traffic/staff/visitor/upload');
    }
    async handleExport() {
        if (!this.portraitsToExport || this.portraitsToExport.length === 0) {
            this.$elmessage(this.$t('selection').toString());
            return;
        }
        try {
            const res = await StaffModule.exportPortraits({ libraryType: 0, portraitIds: this.portraitsToExport });
            console.log('res:', process.env);
            this.$alert(this.$t('common.csv').toString(), '', {
                confirmButtonText: this.$t('common.confirm').toString(),
                callback: (action) => {
                    if (action === 'confirm') {
                        const path = process.env.NODE_ENV === 'development'
                            ? `https://bj.cluster21.xplorer.sensetime.com${res.data}`
                            : `${window.location.protocol}//${window.location.host}${res.data}`;
                        const a = document.createElement('a');
                        a.href = path;
                        a.click();
                    }
                },
            });
        }
        catch (e) { }
    }
    handleFilter(filters) {
        console.log('filters:', filters);
        this.params.libId = filters.group;
        this.getData();
    }
};
__decorate([
    Prop({ type: Array })
], default_1.prototype, "childId", void 0);
default_1 = __decorate([
    Component({
        name: 'portrait',
        components: { AuthItem, XplorerTable, InvisibleNumber },
        i18n: {
            messages: {
                'en-us': {
                    name: 'Name',
                    id: 'ID Number',
                    portrait: 'ID Portrait',
                    group: 'User Group',
                    ppl: 'Creator',
                    update: 'Update',
                    visitpurpose: 'Visit purpose',
                    visitor: 'User group',
                    state: 'Status',
                    valid: 'Valid until',
                    creator: 'Creator',
                    deleteUser: 'Are you sure to delete ',
                    confirm: 'OK',
                    cancel: 'Cancel',
                    deleted: 'Delete successfully',
                    selections: 'No row selected',
                },
                zh: {
                    name: '名字',
                    id: 'ID 号',
                    portrait: '证件头像',
                    group: '人员组',
                    ppl: '创建人',
                    update: '更新时间',
                    visitpurpose: '访问目的',
                    visitor: '访客组',
                    state: '访客状态',
                    valid: '访问有效期',
                    creator: '创建人',
                    deleteUser: '确认删除 ',
                    confirm: '确认',
                    cancel: '取消',
                    deleted: '成功删除',
                    selections: '没有选择导出列',
                },
            },
        },
    })
], default_1);
export default default_1;
